import { createContext, useContext } from 'react'

const TENANT_SLUG_KEY = 'trellis_tenant_slug'
const TENANT_DISPLAY_NAME_KEY = 'trellis_tenant_display_name'
const TENANT_USER_ID_KEY = 'trellis_tenant_user_id'

export function getStoredTenantSlug(): string | null {
  return localStorage.getItem(TENANT_SLUG_KEY)
}

export function setStoredTenantSlug(slug: string): void {
  localStorage.setItem(TENANT_SLUG_KEY, slug)
}

export function clearStoredTenantSlug(): void {
  localStorage.removeItem(TENANT_SLUG_KEY)
}

export function getStoredTenantDisplayName(): string | null {
  return localStorage.getItem(TENANT_DISPLAY_NAME_KEY)
}

export function setStoredTenantDisplayName(displayName: string): void {
  localStorage.setItem(TENANT_DISPLAY_NAME_KEY, displayName)
}

export function clearStoredTenantDisplayName(): void {
  localStorage.removeItem(TENANT_DISPLAY_NAME_KEY)
}

export function getStoredTenantUserId(): string | null {
  return localStorage.getItem(TENANT_USER_ID_KEY)
}

export function setStoredTenantUserId(userId: string): void {
  localStorage.setItem(TENANT_USER_ID_KEY, userId)
}

export function clearStoredTenantUserId(): void {
  localStorage.removeItem(TENANT_USER_ID_KEY)
}

interface TenantContextValue {
  tenantSlug: string | null
  tenantDisplayName: string | null
  setTenant: (slug: string, displayName: string, userId: string) => void
  clearTenant: () => void
}

export const TenantContext = createContext<TenantContextValue>({
  tenantSlug: null,
  tenantDisplayName: null,
  setTenant: () => {},
  clearTenant: () => {},
})

export function useTenant(): TenantContextValue {
  return useContext(TenantContext)
}
